import { useRecoilState } from "recoil";
import { arraySeries } from "../atom";

const useArraySeriesState = () => {
    return useRecoilState(arraySeries);
};

export default useArraySeriesState;